// test979
(979 && 0);
